// Default purple highlight for audio observation regions.
export const AUDIO_OBSERVATION_HIGHLIGHT_COLOR =
  "rgba(147, 51, 234, 0.3)" as const

// rgba palette for audio regions, keyed by pass/fail classification.
export const AUDIO_REGION_COLOR_BY_CLASSIFICATION = {
  success: "rgba(23, 201, 100, 0.35)",
  danger: "rgba(243, 18, 96, 0.35)",
  // Low end of the numerical gradient (t=0): warning orange.
  warning: "rgba(245, 115, 0, 0.35)",
  default: "rgba(113, 113, 122, 0.3)",
} as const

// Orange and success channel values for the numerical gradient.
const WARNING_RGB = [245, 115, 0] as const
const SUCCESS_RGB = [23, 201, 100] as const
const REGION_ALPHA = 0.35

/**
 * Interpolate between the warning and success audio-region colors.
 * @param t - Normalized score in [0, 1] where 1 = full success (green), 0 = warning orange.
 * @returns rgba string.
 */
export function interpolateAudioRegionColor(t: number): string {
  const clamped = Math.max(0, Math.min(1, t))
  const r = Math.round(
    WARNING_RGB[0] + (SUCCESS_RGB[0] - WARNING_RGB[0]) * clamped,
  )
  const g = Math.round(
    WARNING_RGB[1] + (SUCCESS_RGB[1] - WARNING_RGB[1]) * clamped,
  )
  const b = Math.round(
    WARNING_RGB[2] + (SUCCESS_RGB[2] - WARNING_RGB[2]) * clamped,
  )
  return `rgba(${r}, ${g}, ${b}, ${REGION_ALPHA})`
}
